(() => {
  // tabs

  // fn calc height if absolute
  const tabContentHeight = (e) => {
    const container = e.querySelector('.js-category-content.featured');
    const activeTab = e.querySelector('.js-cat-tab.nActive');
    const tabHeight = activeTab.offsetHeight;

    container.style.height = `${tabHeight}px`;
  };

  // activate first tab
  document.querySelectorAll('.js-cat-tabs').forEach((tabWrap) => {
    if (!tabWrap.querySelector('.nActive')) {
      tabWrap.firstElementChild.classList.add('nActive');
    }
  });
  document.querySelectorAll('.js-category-content.featured').forEach((tabContent) => {
    if (!tabContent.querySelector('.nActive')) {
      tabContent.firstElementChild.classList.add('nActive');
    }
  });
  document.querySelectorAll('.js-category-content:not(.featured)').forEach((tabContent) => {
    if (!tabContent.querySelector('.nActive')) {
      tabContent.lastElementChild.classList.add('nActive');
    }
  });

  const categoryTile = document.querySelector('.cat-tiles.griditems');
  if (categoryTile) {
    categoryTile.setAttribute('tab-id', 1);
  }

  // click to change tab
  document.querySelectorAll('.cat-tab-title').forEach((tabTitle) => {
    const changeTab = (e) => {
      const tab = e.currentTarget;
      const tabID = tab.getAttribute('tab-id');
      if (tab.classList.contains('nActive')) return;

      // Tab Title
      tab.parentNode.querySelector('.nActive')?.classList.remove('nActive');
      tab.classList.add('nActive');

      // Tab Content
      tabTitle.parentNode.nextElementSibling.querySelector('.nActive')?.classList.remove('nActive');
      tabTitle.parentNode.nextElementSibling.querySelector(`[tab-id="${tabID}"`).classList.add('nActive');
      // $('.js-carousel-slider').slick('refresh');

      // BG Image
      tabTitle.closest('.js-tabs-container.featured')?.querySelector('.js-tab-images .nActive')?.classList.remove('nActive');
      tabTitle.closest('.js-tabs-container.featured')?.querySelector(`.js-tab-images [tab-id="${tabID}"`)?.classList.add('nActive');

      // for content tabs, we need to calc height as pos: absolute
      if (tab.closest('.module-content-tabs')) {
        tabContentHeight(tab.closest('.module-content-tabs'));
      }

      // Background Color Change

      const parentDiv = tab.closest('.tab-title-wrap');

      // Check if the background change class should be removed or added based on active tab-id

      if (tabID === '0' && parentDiv.classList.contains('right')) {
        parentDiv.classList.remove('right');
      } else if (tabID === '1' && !parentDiv.classList.contains('right')) {
        parentDiv.classList.add('right');
      }
    };

    const featuredTab = document.querySelector('.js-category-content.featured');
    if (featuredTab) {
      tabTitle.addEventListener('click', (e) => {
        changeTab(e);
      });

      tabTitle.addEventListener('keyup', (e) => {
        if (!(e.key === 'Enter')) return;
        changeTab(e);
      });
    }
  });
})();
